<template>
  <div id="main">
    <div class="wrapper" v-if="$store.state.isLoggedIn">
      
      <template >
        <app-header/>
        <div id="content">
          <div class="nav-steps-container" style>
            <div class="container" style="padding:0">
              <ul class="nav-steps">
                <li v-if="!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')">
                  <router-link to="/chatbot" v-if="isSelectedBot">
                    <h3 style="margin: 5px 0 0 0;">
                      <i class="fas fa-comments"></i>
                    </h3>Chatbot
                  </router-link>
                </li>
                <li>
                  <router-link to="/dashboard" v-if="isSelectedBot">
                    <h3 style="margin: 5px 0 0 0;">
                      <span class="glyphicon glyphicon-dashboard"></span>
                    </h3>Analytics
                  </router-link>
                </li>
                <li v-if="!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')">
                  <router-link to="/setting" v-if="isSelectedBot">
                    <h3 style="margin: 5px 0 0 0;">
                      <i class="fas fa-cog"></i>
                    </h3>Setting
                  </router-link>
                </li>
                <li v-if="!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin')">
                  <router-link to="/template" v-if="isSelectedBot">
                    <h3 style="margin: 5px 0 0 0;">
                      <i class="fas fa-plug"></i>
                    </h3>
                    <span
                      class="hidden-xs"
                    >{{ selectedBot.theme == 'ecommercebasic' ? 'Shop' : 'Manage' }}</span> Plugin
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="container" style="margin-top:15px" v-if="selectedBot">
            <div v-if="!selectedBot.status" class="alert alert-warning" role="alert">
              <strong>Warning!</strong> Your bot will not be collecting data when it's stopped.
              <router-link to="/setting">Go to Settings to activate the bot.</router-link>
            </div>
            <!-- <div v-if="expriedDate <= 10" class="alert alert-warning" role="alert">
              <strong>Warning!</strong>
              Your Chatbot package will be expire in {{expriedDate}} days. Please go to
              <router-link to="/setting?tab=billing">billing section</router-link>to proceed payment and extend the package.
            </div> -->
          </div>

          <router-view/>
        </div>
        <app-footer/>
      </template>
      <template v-if="false">
        <app-header/>
        <div id="content">
          <div class="container">
            <div role="alert">
              <div class="text-center" style="margin: 35px 0">
                <img src="/static/img/assets/setting/expired_alert@2x.png" alt style="width: 230px">
                <h3>You Chatbot package is expired</h3>
                <p>You Chatbot package is expired, please choose the package below to extend the package. Please contact email
                  <a :href="'mailto:'+$store.state.theme.email_contact">{{$store.state.theme.email_contact}}</a> for more information.
                </p>
                <!-- <a href="javascript:void(0);" class="btn btn-primary"  data-toggle="modal" data-target="#modal_add_product">Add Product</a> -->
              </div>
            </div>
            <hr>
            <view-package style="margin-bottom: 45px;"></view-package>
          </div>
        </div>
        <app-footer/>
      </template>
    <modal-welcome></modal-welcome>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import header from "@/components/elements/header";
import footer from "@/components/elements/footer";
import dropdown from "@/components/elements/dropdown";
import moment from "moment";
import ModalDialog from "@/components/elements/ModalDialog";
import ModalWelcome from "@/components/elements/ModalWelcome";

import ViewPackage from "@/components/view/setting/ViewPackage";

import config from "@/config";
import api from "@/api";

export default {
  // name: "dashboard",
  components: {
    "app-header": header,
    "app-footer": footer,
    "app-dropdown": dropdown,
    ViewPackage,
    ModalDialog,
    ModalWelcome
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: "botlist",
      isSelectedBot: "isSelectedBot",
      isFacebook: "isFacebook"
    }),
    // selectedBot: {
    //   get() {
    //     if (this.$store.state.selectedBot == null) {
    //       return null;
    //     }
    //     return this.$store.state.selectedBot;
    //   }
    // },
    expriedDate: function() {
      if (this.$store.state.selectedBot) {
        var now = moment();
        var expriedDate = moment(this.$store.state.selectedBot.expireat);
        return expriedDate.diff(now, "days");
        // return 10
      } else {
        return null;
      }
    },
    optionBotlist: function() {
      let options = [];
      let vm = this;
      $.each(vm.botlist, function(index, val) {
        options.push({ name: val.pagename, value: val.pageid });
      });

      return options;
    }
  },
  data: function() {
    return {
      currentBot: null
      // expriedDate: null,
    };
  },
  mounted: function() {
    var vm = this;
    vm.getSetting(function(contents) {
      vm.$store.dispatch("updateSetting", contents);
    });

    vm.getWelcomeMessage(function(welcomeMessage) {
      vm.$store.dispatch("updateWelcomeMessage", welcomeMessage);
    });
  },
  created: function() {},
  methods: {
    logout: function() {
      if (confirm("Do you want to logout?")) {
        var isFacebook = this.isFacebook;
        this.$store.dispatch("logout", {}).then();
        if (isFacebook) {
          this.$router.push("/login");
        } else {
          this.$router.push("/nigol");
        }
      }
    },
    getSetting: function(callback) {
      let vm = this;
      var data = {
        pageid: vm.$store.state.selectedBot.pageid
      };

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error);
          return;
        }

        var contents = {};
        $.each(response.data, function(index, val) {
          contents[val.contenttype] = val;
        });
        callback(contents);
      });
    },
    getWelcomeMessage: function(callback) {
      let vm = this;
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid
      };

      var message = null;
      var generics = [
        {
          image_url: null,
          title: "",
          subtitle: "",
          buttons: [],

          enable: true
        }
      ];
      var type = "message";
      api.getWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error);
          return;
        }
        if (response.data) {
          type = response.data.type;
          message = response.data.message_text
            ? response.data.message_text
            : "";
          if (
            response.data.message &&
            typeof response.data.message === "object" &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function(index, val) {
              generics[index] = val;
              generics[index].enable = true;
            });
          }
        }
        callback({
          type: type,
          message: message,
          generics: generics
        });
      });
    }
  }
};
</script>

<style scroped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/Main.vue